// Cognito error code list
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_AdminListUserAuthEvents.html

// allow localization outside component
import { i18n } from 'next-i18next';

const getErrorMessage = (code: string | undefined, message?: string | undefined) => {
  switch (code) {
    case 'AliasExistsException':
      return i18n?.t('error:cognito.given-email-exists');
    case 'CodeMismatchException':
      return i18n?.t('error:cognito.code-mismatch');
    case 'ExpiredCodeException':
      return i18n?.t('error:cognito.expired-code');
    case 'InvalidParameterException':
      return i18n?.t('error:cognito.should-be-email');
    case 'TooManyRequestsException':
      return i18n?.t('error:cognito.attempts-exceed-exception-wait');
    case 'LimitExceededException':
      return i18n?.t('error:cognito.attempts-exceed-exception-wait');
    case 'NotAuthorizedException':
      switch (message) {
        case 'Password attempts exceeded':
          return i18n?.t('error:cognito.attempts-exceed-exception');
        case 'Attempt limit exceeded, please try after some time.':
          return i18n?.t('error:cognito.attempts-exceed-exception-wait');
        default:
          return i18n?.t('error:cognito.incorrect-user-email-password');
      }
    case 'UsernameExistsException':
      return i18n?.t('error:cognito.email-registered');
    case 'UserNotConfirmedException':
      return i18n?.t('error:cognito.user-not-confirmed');
    case 'InvalidPasswordException':
      return i18n?.t('error:cognito.invalid-password');
    case 'InternalErrorException':
      return i18n?.t('error:cognito.unexpected-error');
    case 'ResourceNotFoundException':
      return i18n?.t('error:cognito.unexpected-error');
    default:
      return i18n?.t('error:cognito.unexpected-error');
  }
};

export default getErrorMessage;
